import type { OverviewSurvey } from "../overviewTypes";
import { SURVEY_WAVE_LABELS } from "../overviewTypes";
import { surveyResponseText } from "../surveyFormatting";
import MetricValue from "./MetricValue";

const tiles = {
  fourPrinciples: { title: "Four principles", note: "Average agreement, 1 to 5", unit: "points" },
  weeklyUse: { title: "Weekly use", note: "Several times a week or more", unit: "pp" },
  timeSaved: { title: "Time saved", note: "An hour or more a week (self-reported)", unit: "pp" },
  judgement: { title: "Judgement scenarios", note: "Best response chosen", unit: "pp" },
};

export default function SurveyPanel({ survey, onDetail }: { survey: OverviewSurvey; onDetail?: () => void }) {
  const empty = survey.waves.length > 0 && survey.waves.every(wave => wave.count.status === "empty" && wave.count.value === 0);
  return <section aria-labelledby="staff-survey-title" className="space-y-3">
    <div><h2 id="staff-survey-title" className="font-semibold text-pd-ink">Staff AI survey</h2><p className="mt-1 text-sm text-pd-slate">Staff-reported measures across the survey waves</p></div>
    <div className="rounded-lg border border-pd-rule bg-pd-white p-4">
    {empty ? <p className="text-sm text-pd-slate">Survey results will appear here when staff responses are available.</p> : null}
    {!empty ? <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {survey.tiles.map(tile => <article key={tile.id} aria-label={tiles[tile.id].title} className="min-w-0 rounded border border-pd-rule p-3">
        <h3 className="text-sm font-semibold text-pd-ink">{tiles[tile.id].title}</h3>
        <p className="mt-1 text-xs text-pd-slate">{tiles[tile.id].note}</p>
        <p className="mt-3 text-sm font-semibold text-pd-ink"><MetricValue metric={tile.start} /> <span aria-label="to">→</span> <MetricValue metric={tile.latest} /></p>
        <p className="mt-2 text-xs text-pd-slate">{tile.change === null ? "Comparison not available" : `${tile.change >= 0 ? "+" : ""}${tile.change} ${tiles[tile.id].unit}`}</p>
      </article>)}
    </div> : null}
    {!empty ? <p className="mt-3 text-xs text-pd-slate">Start → {survey.latestWave ? SURVEY_WAVE_LABELS[survey.latestWave] : "latest wave"}</p> : null}
    {!empty ? <ul className="ml-0 list-none p-0 mt-2 flex flex-wrap gap-x-4 gap-y-2 text-xs text-pd-slate">
      {survey.waves.map(wave => <li key={wave.wave}>{SURVEY_WAVE_LABELS[wave.wave]}: {surveyResponseText(wave)}</li>)}
    </ul> : null}
    {!empty ? <div className="mt-4 flex items-center justify-between gap-3 border-t border-pd-rule pt-3 text-xs text-pd-slate"><span>Combined staff responses only</span>{onDetail ? <button type="button" onClick={onDetail} className="rounded border border-pd-rule bg-pd-cream px-3 py-2 text-sm font-medium text-pd-ink">View survey detail</button> : null}</div> : null}
    </div>
  </section>;
}
